module.exports = __webpack_public_path__ + "static/media/placeholder-video.add87c91.svg";